import React from 'react';

const services = [
  {
    icon: "/icons/training.png",
    title: "GUIDANCE FOR PROJECT SELECTION",
    description: "We carry out a scientific survey of business ideas. Our survey consists of local raw material availability, local manpower availability, local market availability, product scalability, etc."
  },
  {
    icon: "/icons/loading-sign.png",
    title: "PROJECT DESIGN",
    description: "Based on market study and budget we design projects on small scale, medium scale, or large scale."
  },
  {
    icon: "/icons/factory.png",
    title: "MANUFACTURING",
    description: "Based on project design we manufacture excellent quality equipment."
  },
  {
    icon: "/icons/tools.png",
    title: "INSTALLATION",
    description: "Most of the projects supplied by us are ready-to-install types. For Medium scale and large-scale projects, our team is always ready for installations on site."
  },
  {
    icon: "/icons/headset.png",
    title: "MARKETING ASSISTANCE",
    description: "Once our supplied project is installed and commissioned, we do assist entrepreneurs in marketing products manufactured from our project/industry."
  },
  {
    icon: "/icons/services.png",
    title: "AFTER SALES SERVICE",
    description: "Normally we keep ready stocks of spare parts required for projects supplied by us after-sales service."
  },
  {
    icon: "/icons/synchronize.png",
    title: "PROJECTS ON TECHNOLOGY TRANSFER",
    description: "We also do total technology transfer projects in the food, Agri, and Engineering sectors."
  }
];

const Services = () => {
  return (
    <section className="py-[80px] bg-white text-center font-body">
      <div className="container mx-auto px-4">
        <div className="mb-[60px]">
          <h2 className="font-display font-bold text-[28px] text-[#001d3d] uppercase tracking-wider mb-4">
            OUR SERVICES
          </h2>
          <p className="text-[#4a5568] text-base max-w-[700px] mx-auto leading-[1.6]">
            We provide the following services and help industries and entrepreneur to build and grow their nations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px] mb-[30px]">
          {services.slice(0, 4).map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-[30px]">
          {services.slice(4).map((service, index) => (
            <div key={index} className="w-full md:w-[calc(50%-15px)] lg:w-[calc(25%-22.5px)]">
              <ServiceCard {...service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ServiceCard = ({ icon, title, description }: { icon: string; title: string; description: string }) => {
  return (
    <div className="bg-white border border-[#e2e8f0] p-[25px] rounded-[8px] shadow-[0px_10px_30px_rgba(0,0,0,0.05)] transition-transform duration-300 hover:-translate-y-[5px] h-full flex flex-col items-center">
      <div className="relative mb-6 h-[100px] w-[100px] flex items-center justify-center">
        <div className="absolute inset-0 flex flex-wrap gap-2 opacity-60">
           <div className="w-1 h-1 rounded-full bg-blue-400 absolute top-2 left-4"></div>
           <div className="w-1.5 h-1.5 rounded-full bg-yellow-400 absolute top-0 right-6"></div>
           <div className="w-1 h-1 rounded-full bg-red-400 absolute bottom-4 left-2"></div>
           <div className="w-2 h-2 rounded-full bg-blue-500 absolute bottom-2 right-8"></div>
        </div>
        
        <img 
          src={icon} 
          alt={title} 
          className="w-[80px] h-[80px] object-contain relative z-10"
        />
      </div>

      <h3 className="font-display font-bold text-[18px] text-[#001d3d] leading-[1.4] mb-4 uppercase text-center">
        {title}
      </h3>
      
      <p className="text-[#4a5568] text-[15px] leading-[1.6] text-center">
        {description}
      </p>
    </div>
  );
};

export default Services;
